export const coefficientFields = [
  { label: 'Место погрузки', field: 'origin_kladr_name', width: 4 },
  { label: 'КЛАДР места погрузки', field: 'origin_kladr_id', width: 3 },
  { label: 'Место выгрузки', field: 'destination_kladr_name', width: 4 },
  { label: 'КЛАДР места выгрузки', field: 'destination_kladr_id', width: 3 },
  { label: 'Минимальная дистанция', field: 'min_distance', width: 3 },
  { label: 'Максимальная дистанция', field: 'max_distance', width: 3 },
  { label: 'Коэффициент', field: 'price_per_ton', width: 3 },
]
